import React, { useEffect, useState } from "react";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { filterWondersoftDrugs, getDrugById } from "core/services/api";
import Toast from 'components/Toast';

const ChemotherapyRow = ({ chemotherapyInfo,
  provider, readOnly, appointmentDetails, order, i, j, setChemotherapyInfo, title, handleChange, handleBlur, selectedInputValues, newMedicine, setSelectedInputValues, handleInputChange, adjustTextareaHeight, handleChangeDurationChemo, setInputValueChemo, options1Chemo, allDrugs
}: any): JSX.Element => {

  const [medicineOptions, updateMedicineOptions] = useState([])

  const [drugDosage, setDrugdosage] = useState<any>()
  const [showdrugValidation, setShowdrugvalidation] = useState(false)
  const fetchDosage = (drugId: any) => {
    getDrugById(drugId).then((res) => {
      setDrugdosage(res)
    })
  }

  const drugDosageValidation = (value: any) => {
    if (Object.keys(drugDosage).length > 0) {
      const numericValueDosage = parseFloat(drugDosage?.upperLimit?.match(/\d+/)[0]);
      const numericValue = parseFloat(value?.match(/\d+/)[0]);
      if (drugDosage?.upperLimit !== null && drugDosage?.lowerLimit !== null) {
        if (
          (numericValue > numericValueDosage)
        ) {
          setShowdrugvalidation(true)
        }
      }
    }
  }

  function fetchMedicine() {
    const temp = allDrugs?.map((each: any) => ({
      label: each?.brandName,
      value: each?.id,
    }))
    const sortedTemp = temp?.sort((a: any, b: any) => {
      if (a?.label?.toLowerCase() < b?.label.toLowerCase()) {
        return -1
      }
      if (a?.label.toLowerCase() > b?.label.toLowerCase()) {
        return 1
      }
      return 0
    })

    updateMedicineOptions(sortedTemp)
  }

  useEffect(() => {
    fetchMedicine()
  }, [allDrugs])

  const filterDrugType = (drugType: any, searchText: any) => {
    let url = "";
    if (drugType) {
      url = `?drugType=${drugType}`;
    }
    if (searchText) {
      if (url === "") {
        url = `?searchText=${searchText}`;
      } else {
        url = url + `&searchText=${searchText}`;
      }
    }

    filterWondersoftDrugs(url)
      .then((res: any) => {
        const temp = res?.map((each: any) => ({
          label: each?.brandName,
          value: each?.id,
        }))
        const sortedTemp = temp?.sort((a: any, b: any) => {
          if (a?.label?.toLowerCase() < b?.label.toLowerCase()) {
            return -1
          }
          if (a?.label.toLowerCase() > b?.label.toLowerCase()) {
            return 1
          }
          return 0
        })
        updateMedicineOptions(sortedTemp)
      })
      .catch((err: any) => {
        console.log("filter drug type error", err)
      })

  }

  return (
    <>
      < div className="dynamic-parent-chemo" key={j} ref={provider.innerRef} {...provider.draggableProps} >
        <div><div {...provider.dragHandleProps} className={`dynamic-child ${readOnly ? "read-only" : ""} ${(
          chemotherapyInfo[i]?.isCancelled ? true : false || readOnly || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))
        ) ? "disabledDiv" : ""}`}
          style={{
            margin: "0px 0px 5px 0px",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center"
          }}>
          <img src="../../../../assets/images/drag-drop-icon.svg"
            style={{ marginBottom: "3px", marginRight: "5px" }} />
          {j + 1}</div>
        </div>
        <div>
         
          <Select
            className={`dynamic-child ${readOnly ? "read-only" : ""} ${(
              chemotherapyInfo[i]?.isCancelled ? true : false || readOnly || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))
            ) ? "disabledDiv" : ""}`}
            defaultValue={{
              label: "",
              value: ""
            }}
            value={{
              label: chemotherapyInfo[i].medicines[j].type,
              value: ""
            }}
            name="type"
            options={
              (chemotherapyInfo[i].medicines[j].typeOptions && chemotherapyInfo[i].medicines[j].typeOptions.length > 0)
                ? chemotherapyInfo[i].medicines[j].typeOptions.map((options: any) => ({
                  label: options,
                  value: options
                }))
                : title
            }
            onChange={(e: any) => {
              const values = [...chemotherapyInfo]
              values[i].medicines[j].type = e?.value
              setChemotherapyInfo([...values]);
              filterDrugType(e?.value, "");
            }}
            isDisabled={chemotherapyInfo[i]?.isCancelled ? true : false || readOnly || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))}
          />

        </div>
        <div title={chemotherapyInfo[i].medicines[j]?.medicineName}>


          <CreatableSelect
            isClearable
            // defaultInputValue={eachPrescription?.medicineName}
            isDisabled={chemotherapyInfo[i]?.isCancelled ? true : false || readOnly || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))}
            className={`dynamic-child med-name-style-chemo ${readOnly ? "read-only" : ""} ${(
              chemotherapyInfo[i]?.isCancelled ? true : false || readOnly || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))
            ) ? "disabledDiv" : ""}`}
            // value={
            //   chemotherapyInfo[i].medicines[j]?.medicineName
            //     ? medicineOptions.filter(
            //       ({ label }) => label === chemotherapyInfo[i].medicines[j].medicineName
            //     )
            //     : newMedicine?.chemotherapy
            // }
            value={
              chemotherapyInfo[i].medicines[j]?.medicineName
                ? medicineOptions?.filter(
                  ({ label }) => label === chemotherapyInfo[i].medicines[j]?.medicineName
                )?.length > 0 ? medicineOptions?.filter(
                  ({ label }) => label === chemotherapyInfo[i].medicines[j]?.medicineName
                ) : { label: chemotherapyInfo[i].medicines[j]?.medicineName, value: chemotherapyInfo[i].medicines[j]?.medicineName }
                : newMedicine
            }
            onChange={(e: any) => {
              handleChange(e, i, j, "chemotherapy");
              fetchDosage(e?.value);
              handleBlur("chemotherapyAdministration", i, j);
            }}
            onFocus={(e) => {
              handleInputChange("chemotherapyAdministration", i, j, chemotherapyInfo[i].medicines[j]?.medicineName);
            }}
            inputValue={selectedInputValues?.chemotherapyAdministration?.[i]?.medicines?.[j]}
            onInputChange={(newValue: string) => {
              if (newValue !== undefined) {
                const selected: any = { ...selectedInputValues };
                if (!selected["chemotherapyAdministration"][i]) {
                  selected["chemotherapyAdministration"][i] = { medicines: [] };
                }
                selected["chemotherapyAdministration"][i]["medicines"][j] = newValue;
                setSelectedInputValues(selected);
              } else {
                const selected: any = { ...selectedInputValues };
                selected["chemotherapyAdministration"][i]["medicines"][j] = "";
                setSelectedInputValues(selected);
              }
            }}
            options={medicineOptions}
            filterOption={(option: any, input: any) => option?.label?.toLowerCase()?.includes(input?.toLowerCase())}

          />
        </div>

        <div>
          <input
            value={chemotherapyInfo[i].medicines[j].standardDose}
            className={`dynamic-child ${readOnly ? "read-only" : ""}`}
            style={{ whiteSpace: 'pre-wrap', padding: '5px 8px' }}
            name="standardDose"
            onChange={(e: any) => {
              const values = [...chemotherapyInfo]
              values[i].medicines[j].standardDose = e.target.value
              setChemotherapyInfo([...values]);

            }}

            disabled={chemotherapyInfo[i]?.isCancelled ? true : false || readOnly || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))}
          />
        </div>
        <div>
          <input
            value={chemotherapyInfo[i].medicines[j].dose}
            className={`dynamic-child ${readOnly ? "read-only" : ""}`}
            name="dose"
            type="text"
            style={{ whiteSpace: 'pre-wrap', padding: '5px 8px' }}
            onChange={(e: any) => {
              const values = [...chemotherapyInfo]
              values[i].medicines[j].dose = e.target.value
              setChemotherapyInfo([...values]);

            }}
            onBlur={(e: any) => {
              const values = [...chemotherapyInfo]
              values[i].medicines[j].dose = e.target.value
              setChemotherapyInfo([...values]);
              drugDosageValidation(e.target.value);
            }}
            disabled={chemotherapyInfo[i]?.isCancelled ? true : false || readOnly || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))}
          />
        </div>
        <div>
          <input
            value={chemotherapyInfo[i].medicines[j].doseModification}
            style={{ whiteSpace: 'pre-wrap', padding: '5px 8px' }}
            className={`dynamic-child ${readOnly ? "read-only" : ""}`}
            type="text"
            name="doseModification"
            onChange={(e: any) => {
              const values = [...chemotherapyInfo]
              values[i].medicines[j].doseModification = e.target.value
              setChemotherapyInfo([...values]);
            }}
            disabled={chemotherapyInfo[i]?.isCancelled ? true : false || readOnly || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))}
          />
        </div>
        <div>
          <input
            value={chemotherapyInfo[i].medicines[j].route}
            className={`dynamic-child ${readOnly ? "read-only" : ""}`}
            style={{ whiteSpace: 'pre-wrap', padding: '5px 8px' }}
            name="route"
            onChange={(e: any) => {
              const values = [...chemotherapyInfo]
              values[i].medicines[j].route = e.target.value
              setChemotherapyInfo([...values]);
            }}
            disabled={chemotherapyInfo[i]?.isCancelled ? true : false || readOnly || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))}
          />
        </div>
        <div>
          <textarea
            rows={1}
            style={{
              minHeight: "100%", whiteSpace: 'pre-wrap', padding: '5px 8px', display: "flex",
              alignItems: "center",
              overflow: "hidden",
              resize: "none"
            }}
            value={chemotherapyInfo[i].medicines[j].instructions}
            className={`autoHeightTextarea dynamic-child ${readOnly ? "read-only" : ""}`}
            name="route"
            onChange={(e: any) => {
              const values = [...chemotherapyInfo]
              values[i].medicines[j].instructions = e.target.value
              setChemotherapyInfo([...values]);
              adjustTextareaHeight();
            }}
            disabled={chemotherapyInfo[i]?.isCancelled ? true : false || readOnly || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))}
          />
        </div>
        <div>
          <Select
            isClearable={true}
            value={{
              label: chemotherapyInfo[i].medicines[j].duration,
              value: chemotherapyInfo[i].medicines[j].duration
            }}
            className={`dynamic-child ${readOnly ? "read-only" : ""} ${(
              chemotherapyInfo[i]?.isCancelled ? true : false || readOnly || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))
            ) ? "disabledDiv" : ""}`}
            name="duration"
            onChange={(e: any) => {
              const values = [...chemotherapyInfo]
              values[i].medicines[j].duration = e.value
              setChemotherapyInfo([...values]);
              setInputValueChemo(e ? e.value : '');
            }}
            onInputChange={(inputValue) => handleChangeDurationChemo({ value: inputValue, label: inputValue })}
            options={options1Chemo}
            isDisabled={chemotherapyInfo[i]?.isCancelled ? true : false || readOnly || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))}
          />
        </div>


        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>

          <input
            type="checkbox"
            checked={
              chemotherapyInfo[i]?.medicines[j]?.sideEffectCheck
            }
            name="sideEffectCheck"
            onChange={(e: any) => {
              const values = [...chemotherapyInfo]
              values[i].medicines[j].sideEffectCheck = e.target.checked
              setChemotherapyInfo([...values]);
            }}
            disabled={chemotherapyInfo[i]?.isCancelled ? true : false || readOnly || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))}
          />


        </div>
        {chemotherapyInfo[i].medicines.length > 1 ? (
          !readOnly && (
            <button
              className="delete-icon"
              onClick={() => {
                const values = [...chemotherapyInfo]

                if (values[i].medicines.length > 1) {
                  values[i].medicines.splice(j, 1)
                  setChemotherapyInfo(values)

                  const selected: any = { ...selectedInputValues }
                  selected["chemotherapyAdministration"][i]["medicines"].splice(j, 1)
                  setSelectedInputValues(selected)
                }

              }}
              disabled={chemotherapyInfo[i]?.isCancelled ? true : false || readOnly || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))}
            >
              <img
                src="../../../../assets/images/delete-icon.svg"
                alt=""
              />
            </button>
          )) : (
          !readOnly && (
            <button
              className="delete-icon"
              style={{ cursor: "not-allowed" }}
            >
              <img
                src="../../../../assets/images/delete-icon.svg"
                alt=""
              />
            </button>
          ))
        }
      </div>
      {showdrugValidation && (
        <Toast
          textMessage={`Check the UpperLimit ${drugDosage?.upperLimit === null ? "" : drugDosage?.upperLimit} `}
          onCloseText={"Close"}
          type={"error"}
          onClose={() => setShowdrugvalidation(false)}
        ></Toast>
      )}
    </>

  );

}

export default ChemotherapyRow;